//Generated File 
export default class ApplicationVersion{
	static readonly BUILD_DAY = 16;
	static readonly BUILD_HOUR = 21;
	static readonly BUILD_MINUTE = 9;
	static readonly BUILD_MONTH = 7;
	static readonly BUILD_YEAR = 2026;
	static readonly DATABASE_VERSION = 150;
	static readonly SERVER_VERSION = 7;
}
